import { Check, Minus } from "lucide-react";
import { SectionHeading } from "./SectionHeading";
import { Reveal } from "./Reveal";

const ROWS = [
  ["Oltre 30 ore di formazione", true, true],
  ["Approfondimenti biblici", true, true],
  ["Deserto 40 giorni", true, true],
  ["Routine quotidiane", true, true],
  ["Allenamenti", true, true],
  ["Ricette", true, true],
  ["Diario personale", true, true],
  ["Versetti e riflessioni", true, true],
  ["Social interno", true, true],
  ["Pubblicazione post e immagini", true, true],
  ["Chat interne", true, true],
  ["Gruppi uomini e donne", true, true],
  ["Gruppi single e coppie", true, true],
  ["Incontri settimanali di gruppo", false, true],
  ["Gruppo WhatsApp privato", false, true],
  ["Contatto WhatsApp con Elio e Chiara", false, true],
];

const Cell = ({ included }) =>
  included ? (
    <Check
      className="mx-auto h-5 w-5 text-[#C9A45C]"
      aria-label="Incluso"
      role="img"
    />
  ) : (
    <Minus
      className="mx-auto h-5 w-5 text-[#3a3a3a]"
      aria-label="Non incluso"
      role="img"
    />
  );

export const ComparisonTable = () => (
  <section id="confronto" className="bg-[#121212] py-24 sm:py-32">
    <div className="mx-auto max-w-4xl px-6 lg:px-8">
      <SectionHeading
        eyebrow="Tabella comparativa"
        title="Quale percorso fa per te?"
        testid="comparison-heading"
      />
      <Reveal>
        <div
          data-testid="comparison-table"
          className="overflow-hidden rounded-sm border border-[#1B1B1B] bg-[#080808]"
        >
          <div className="grid grid-cols-[1fr_auto_auto] items-center gap-2 border-b border-[#C9A45C]/40 bg-[#121212] px-4 py-4 sm:grid-cols-[1fr_140px_140px] sm:px-6">
            <span className="text-xs font-bold uppercase tracking-widest text-white">
              Funzionalità
            </span>
            <span className="w-16 text-center text-[10px] font-bold uppercase tracking-widest text-[#B8B8B8] sm:w-auto sm:text-xs">
              App 9,99&nbsp;€
            </span>
            <span className="w-16 text-center text-[10px] font-bold uppercase tracking-widest text-[#C9A45C] sm:w-auto sm:text-xs">
              Community 49&nbsp;€
            </span>
          </div>
          {ROWS.map(([feature, app, community], i) => (
            <div
              key={feature}
              data-testid={`comparison-row-${i + 1}`}
              className={`grid grid-cols-[1fr_auto_auto] items-center gap-2 px-4 py-3.5 sm:grid-cols-[1fr_140px_140px] sm:px-6 ${
                i % 2 === 0 ? "bg-[#080808]" : "bg-[#0d0d0d]"
              } ${!app ? "border-t border-[#C9A45C]/20" : ""}`}
            >
              <span className="text-sm text-[#B8B8B8]">{feature}</span>
              <span className="w-16 sm:w-auto">
                <Cell included={app} />
              </span>
              <span className="w-16 sm:w-auto">
                <Cell included={community} />
              </span>
            </div>
          ))}
        </div>
      </Reveal>
    </div>
  </section>
);
